import { setAuth, vars } from "@/shared/lib";
import { Center, Indicator } from "@/shared/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useMount } from "react-use";

type DeeplinkSearch = {
	accessToken: string;
	refreshToken: string;
};

export const Route = createFileRoute("/(non-auth)/deeplink/")({
	component: Deeplink,
	validateSearch: (search: Record<string, unknown>): DeeplinkSearch => {
		return {
			accessToken: (search.accessToken as string) ?? "",
			refreshToken: (search.refreshToken as string) ?? ""
		};
	}
});

/**
 * @returns  {
		?accessToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJyb2xlIjoiRU1QTE9ZRUUiLCJhdXRob3JpdHkiOiJNQU5BR0VSIiwiZXh0ZXJuYWxfaWQiOiJlOTk5NDFlZS1iMGY3LTQzZmItOThlYS0yNGQ1ZGEzYmJkYTciLCJleHAiOjE3MzI5OTA0NjJ9.nFVn2rfEreqUdkOoUhqR2B8svOUK43aNCAScLxZZ6-8DnlTfHCeCc9C-8YKIRfQGbdKfNsx6B6FAKQBdJYNZNw&refreshToken=aa310a04-768f-4cb2-806e-7bc76373a0fc
	}
 */

function Deeplink() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	useMount(() => {
		if (!search.accessToken || !search.refreshToken) {
			navigate({
				to: "/login",
				search: {
					step: "OPENING"
				},
				replace: true
			});
		} else {
			setAuth({ accessToken: search.accessToken, refreshToken: search.refreshToken });

			navigate({
				to: "/",
				replace: true
			});
		}
	});

	return (
		<Center
			style={{
				width: "100%",
				height: "100vh",

				backgroundColor: vars.color.gray[50]
			}}
		>
			<Indicator />
		</Center>
	);
}
